/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
// Copyright 2021 channysok
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
//     http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var devMode = false
// var devMode = true
export default {
    dev_mode: devMode,
    // base_api_url: 'http://localhost:8381/api/v1',    
    base_api_url: devMode ? 'https://globalapi-dev.joonaakhub.com/api/v1' : 'https://global-api.joonaakhub.com/api/v1',
    basic_key: "Basic Sk5UcnVzdDpKTlNlY3JldA==",
    pageSize: 30,
    appVersion: '1.3.7'
}